<script setup>

	const url = useRequestURL()

	const { data: page } = await useAPIFetch('OurPartners')
	const partners = page.value.body.find(item => item.specific === 'Partners')
	const becomePartner = page.value.body.find(item => item.specific === 'BecomePartner')

	useHeadData({
		title: page.value.meta.title,
		description: page.value.meta.description,
		author: page.value.meta.author,
		copyright: page.value.meta.copyright,
		keywords: page.value.meta.keywords,
		og: page.value.meta.og,
		url: url.href
	})

</script>

<template>
	<div class="container mt-10">
		<div class="grid grid-cols-2">
			<div class="col-span-2 xl:col-span-1">
				<h1 class="text-lilac mb-8 h2">{{ page.attrs.title }}</h1>

				<WysiwygPerexSmall class="mb-12 xl:mb-20" :value="page.attrs.perex" />
			</div>

			<div class="col-span-2">
				<div v-if="partners?.items?.length" class="mb-24">
					<h2 class="text-lilac h4 mb-6">{{ partners.title }}</h2>
					<div class="grid md:grid-cols-2 lg:grid-cols-3 md:gap-x-8 gap-y-10 md:gap-y-20">
						<div v-for="(partner, index) in partners.items" :key="index">
							<div class="h-[120px] text-center flex items-center justify-center mb-5">
								<img class="max-h-full max-w-full" :src="partner.image?.url" :alt="partner.title">
							</div>
							<div class="dark:text-light text-dark text-base xl:text-lg" v-html="partner.description"></div>
						</div>
					</div>
				</div>
			</div>

			<div class="col-span-2 xl:col-span-1">
				<div v-if="becomePartner?.id" class="mb-24">
					<h2 class="text-lilac h4 mb-6">{{ becomePartner.title }}</h2>
					<p class="dark:text-light text-dark">
						<span v-html="$t('partners.become-partner-text')"></span> 
						&nbsp;<a class="link" :href="`mailto:${becomePartner.email}`">{{ becomePartner.email }}</a>
					</p>
				</div>
			</div>
		</div>
	</div>
</template>